"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Spinner;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = {
  "container": "spinner-module__container___wsFbS",
  "rotate_rects": "spinner-module__rotate_rects___mgaib"
}; // TODO: integrate with LoadingIndicator and AuButton
function Spinner({
  className
}) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (0, _classnames.default)(className, styles.container),
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "10%",
    y: "10%",
    width: "80%",
    height: "80%",
    rx: "20"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "25%",
    y: "25%",
    width: "50%",
    height: "50%",
    rx: "10"
  }));
}